import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Link, Typography } from '@mui/material';
//TODO: delete if client is agreed to pdf version
// import { TERMS_AND_CONDITIONS } from 'constants/paths';

import { ContentWrapper } from 'components/_basic/ContentWrapper/ContentWrapper';

import styles from './AccountSettings.module.scss';

export const AccountTermsAndConditions = () => {
  const { t } = useTranslation();

  return (
    <ContentWrapper>
      <Box className={styles.termsAndConditionsWrapper}>
        <Typography variant="h5">{t('termsAndConditions')}</Typography>
        <Link className={styles.termsAndConditionsLink} href="Terms-of-Service.pdf" target="_blank" rel="noopener noreferrer">
          {t('view')}
        </Link>
      </Box>
    </ContentWrapper>
  );
};
